/*
  Accessibility enhancement for the existing ".accordion-container .set > a"
  FAQ toggles (category-page question/answer lists).
  The actual show/hide + fa-plus/fa-minus icon swap is handled elsewhere
  (theme.js, jQuery, toggling an ".active" class) — this script does not
  duplicate or replace that. It only:
    - gives each toggle a button role and an aria-expanded state
    - links each toggle to its answer panel via aria-controls
    - keeps aria-expanded in sync with the "active" class, however it changes
    - adds Space-bar activation (native <a> only responds to Enter)
*/
(function () {
  "use strict";

  var toggles = document.querySelectorAll(".accordion-container .set > a");
  if (!toggles.length) return;

  toggles.forEach(function (toggle, index) {
    var panel = toggle.parentElement.querySelector(":scope > .content");
    if (!panel) return;

    if (!panel.id) {
      panel.id = "tt-faq-panel-" + index;
    }
    toggle.setAttribute("role", "button");
    toggle.setAttribute("aria-controls", panel.id);
    toggle.setAttribute(
      "aria-expanded",
      toggle.classList.contains("active") ? "true" : "false"
    );

    toggle.addEventListener("keydown", function (e) {
      if (e.key === " " || e.key === "Spacebar") {
        e.preventDefault();
        toggle.click();
      }
    });

    if ("MutationObserver" in window) {
      new MutationObserver(function () {
        toggle.setAttribute(
          "aria-expanded",
          toggle.classList.contains("active") ? "true" : "false"
        );
      }).observe(toggle, { attributes: true, attributeFilter: ["class"] });
    }
  });
})();
